import '@descope-ui/descope-text'
import '@descope-ui/descope-icon'
import { componentName, CollapsibleContainerClass } from './CollapsibleContainerClass';

customElements.define(componentName, CollapsibleContainerClass);

export { CollapsibleContainerClass, componentName };
